import {
    createAsyncThunk,
} from "@reduxjs/toolkit";
import api from "./api";


export const getMembers = createAsyncThunk(
    "getMembers",
    async (query = '') => {
        let queryString = new URLSearchParams(query).toString()
        const getActivities = await api.get(`mentee_program/launched-programs${queryString}`);
        if (getActivities.status === 200 && getActivities.data) {
            return getActivities.data;
        }
        return getActivities;
    }
);
export const deleteUser = createAsyncThunk(
    "deleteUser",
    async (data) => {
        const deleteUserInfo = await api.post(`users/delete`, data);
        if (deleteUserInfo.status === 200 && deleteUserInfo.data) {
            return deleteUserInfo.data;
        }
        return deleteUserInfo;
    }
);

export const getMembersList = createAsyncThunk(
    "getMembersList",
    async (query = '') => {
        let queryString = Object.entries(query).map(([key, value])=>`${key}=${value}`).join("&")
        // new URLSearchParams(query).toString()
        const getMembersInfo = await api.get(`members/member-list?${queryString}`);
        if (getMembersInfo.status === 200 && getMembersInfo.data) {
            return {
                role: query.role_name||"admin",
                data: getMembersInfo.data
            };
        }
        return getMembersInfo;
    }
);

export const getMembersExportList = createAsyncThunk(
    "getMembersExportList",
    async (query = '') => {
        let queryString = Object.entries(query).map(([key, value])=>`${key}=${value}`).join("&")
        // new URLSearchParams(query).toString()
        const getMembersInfo = await api.get(`members/member-list?${queryString}`,{responseType:"blob"});
        if (getMembersInfo.status === 200) {
            return getMembersInfo.data;
    
        }
        return getMembersInfo;
    }
);

export const deactivateUser = createAsyncThunk(
    "deactivateUser",
    async (data) => {
        const deactivateUserInfo = await api.post(`members/members-request`, data);
        if (deactivateUserInfo.status === 200 && deactivateUserInfo.data) {
            return deactivateUserInfo.data;
        }
        return deactivateUserInfo;
    }
);

export const activateUser = createAsyncThunk(
    "activateUser",
    async(data) =>{
        const activateInfo = await api.post(`members/active`,data);
        if(activateInfo.status===200 && activateInfo.data){
            return activateInfo.data;

        }
        return activateInfo;
    }
)

